import axios from 'axios'
import {router} from '../router'

// 创建一个Axios实例
const api = axios.create({
  baseURL: '/api', // 你的API基础URL
});

// 添加请求拦截器
api.interceptors.request.use(config => {
  // 在发送请求之前做些什么
  const jwt = localStorage.getItem('token');
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`; // 使用 Bearer 方案
  }
  return config;
});
// 添加请求拦截器
api.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response;
  },
  error => {
    // 对响应错误做点什么
    if (error.response && error.response.status === 401) {
      console.log('Logging out!!!!!')
      // 未授权，通常表示未登录或登录已过期
      localStorage.removeItem('token'); // 清除本地存储中的token
      router.push('/login'); // 跳转到登录页面
    }
    return Promise.reject(error);
  }
);


export default api;